module.exports = __webpack_public_path__ + "static/media/myPak-NG-Logo-NG.c7ecf08f.png";